@if (show) {
  <div class="custom-popup task-group-popup modal left fade">
    <div class="modal-dialog" (clickOutside)="hideTaskGroupFn($event)">
      <div class="modal-content">
        <div class="modal-header align-items-center">
          <h4 class="modal-title card-title">
            <span class="d-block small-light-text">{{ 'Task Group' | translate }}</span>
            {{selectedTaskGroup?.taskGroupName}}
          </h4>
          <img (click)="hideTaskGroupFn($event);" class="close-popup" src="assets/images/close.png">
        </div>
        <div class="modal-body">
          <app-group-associated-segs
            [loadingAllSEGs]="loadingAllSEGs"
            [exposureAllSEGs]="exposureAllSEGs">
          </app-group-associated-segs>
          <app-group-task-distribution
            [loadingExposureTaskDistribution]="loadingExposureTaskDistribution"
            [exposureTaskDistributionsNew]="exposureTaskDistributionsNew">
          </app-group-task-distribution>
          <app-group-task-samples
            [loadingExposureByTaskGroup]="loadingExposureByTaskGroup"
            [exposureByTaskGroupName]="exposureByTaskGroupName"
            (toggleTaskPopupEmit)="toggleTaskPopupFn($event)">
          </app-group-task-samples>
        </div>
      </div>
    </div>
  </div>
}
